import React from 'react';
import {connect} from 'react-redux';

import {BenchlingDispatch} from 'redux-stores/Store';
import * as RequestTaskSchemaDAO from 'requests/schemas/RequestTaskSchemaDAO';
import * as RequestTaskSchemaReduxActions from 'requests/schemas/RequestTaskSchemaReduxActions';
import CreateSchemaPage from 'schemas/CreateSchemaPage';
import {SCHEMA_TYPES} from 'schemas/spec/SchemaConfigConstants';

interface CreateRequestTaskSchemaPageProps {
  createSchema: () => (dispatch: BenchlingDispatch) => void;
}

export class CreateRequestTaskSchemaPage extends React.PureComponent<CreateRequestTaskSchemaPageProps> {
  render(): JSX.Element {
    return (
      <CreateSchemaPage
        schemaType={SCHEMA_TYPES.REQUEST_TASK}
        createSchema={this.props.createSchema}
        listingUrl={RequestTaskSchemaDAO.taskSchemaListingURL()}
        canCreateWarehouseTableName={false}
      />
    );
  }
}

export default connect(null, {
  createSchema: RequestTaskSchemaReduxActions.createSchema,
})(CreateRequestTaskSchemaPage);
